export const API_BASE_URL = process.env.REACT_APP_API_URL;
export const USER_ENDPOINT = `${API_BASE_URL}`;
export const PRICE_SCHEDULE_MODES = {
  ADD: "Add",
  EDIT: "Change",
  READ_ONLY: "View",
};

// constant route
export const ROUTE_PATHS = {
  PATIENT_PAY_SCHEDULE: "/patient-pay-schedule",
  CLIENT_PATIENT_PAY_SCHEDULE: "/client-patient-pay-schedule",
  PATIENT_PAY_CLIENT_LIMITS: "/patient-pay-client-limits",
  PATIENT_PAY_NOTE: "/patient-pay-schedule-note",
  PATIENT_PAY_TABLE: "/patient-pay-table",
  COPY_PATIENT_PAY_SCHEDULE: "/copy-patient-pay-schedule",
  PATIENT_PAY_SCHEDULE_ADD: "/add-patient-pay-schedule",
  PATIENT_PAY_SCHEDULE_EDIT: "/edit-patient-pay-schedule",
  PATIENT_PAY_SCHEDULE_DISPLAY: "/display-patient-pay-schedule",
  PATIENT_PAY_SCHEDULE_CRITERIA: "/patient-pay-schedule-criteria",
  COPY_PATIENT_PAY_TABLE: "/copy-patient-pay-table",
  ADD_CLIENT_PATIENT_PAY_SCHEDULE: "/add-client-patient-pay-schedule",
  EDIT_CLIENT_PATIENT_PAY_SCHEDULE: "/edit-client-patient-pay-schedule",
  DISPLAY_CLIENT_PATIENT_PAY_SCHEDULE: "/display-client-patient-pay-schedule",
  COPY_PATIENT_PAY_TABLE: "/copy-patient-pay-table",
  ADDITIONAL_PATIENT_PAY: "/additional-patient-pay-schedule",
  PATIENT_PAY_TABLE_NOTE: "/patient-pay-table-note",
  PATIENT_PAY_SCHEDULE_CRITERIA_ADD: "/add-patient-pay-schedule-criteria",

  ADDITIONAL_PATIENT_PAY_SCHEDULE_ADD: "/add-additional-patient-pay",
  ADDITIONAL_PATIENT_PAY_SCHEDULE_EDIT: "/edit-additional-patient-pay",
  ADDITIONAL_PATIENT_PAY_SCHEDULE_DISPLAY: "/display-additional-patient-pay",
  PATIENT_PAY_SCHEDULE_CRITERIA_EDIT: "/edit-patient-pay-schedule-criteria",
  PATIENT_PAY_SCHEDULE_CRITERIA_DISPLAY:
    "/display-patient-pay-schedule-criteria",
  COPAY_SCHEDULE: "/copay-schedule",
  ADDITIONAL_PATIENT_PAY_NOTE: "/additional-patient-pay-note",
  COPAY_SCHEDULE_ADD: "/add-copay-schedule",
  COPAY_SCHEDULE_EDIT: "/edit-copay-schedule",
  COPAY_SCHEDULE_DISPLAY: "/display-copay-schedule",
  PROCESSOR_FEE_TABLE: "/processor-fee-table",
  MIN_MAX_COPAY_STEP: "/min-max-copay-step",
  MIN_MAX_DIFFERENTIAL: "/min-max-differential",
  MIN_MAX_COPAY_DIFFERENTIAL: "/min-max-copay-differential",
  ADDITIONAL_PATIENT_PAY_STEPS: "/additional-patient-pay-steps",
  COPAY_SCHEDULE_STEPS: "/copay-schedule-steps",
  ADDITIONAL_PATIENT_PAY_STEPS_ADD: "/add-additional-patient-pay-steps",
  ADDITIONAL_PATIENT_PAY_STEPS_EDIT: "/edit-additional-patient-pay-steps",
  ADDITIONAL_PATIENT_PAY_STEPS_DISPLAY: "/display-additional-patient-pay-steps",
  COPAY_SCHEDULE_NOTE: "/copay-schedule-note",
  COUPON_PATIENT_PAY_ADD: "/add-coupon-patient-pay",
  COUPON_PATIENT_PAY_EDIT: "/edit-coupon-patient-pay",
  COUPON_PATIENT_PAY_DISPLAY: "/display-coupon-patient-pay",
  COUPON_PATIENT_PAY: "/coupon-patient-pay-gpi-list",
  COPY_COPAY_SCHEDULE: "/copay-schedule-copy",

  ADD_PATIENT_PAY_TABLE_DETAIL: "/add-patient-pay-table-detail",
  EDIT_PATIENT_PAY_TABLE_DETAIL: "/edit-patient-pay-table-detail",
  DISPLAY_PATIENT_PAY_TABLE_DETAIL: "/display-patient-pay-table-detail",
  COPAY_SCHEDULE_ADD: "/add-copay-schedule",
  COPAY_SCHEDULE_EDIT: "/edit-copay-schedule",
  COPAY_SCHEDULE_DISPLAY: "/display-copay-schedule",
  PROCESSOR_FEE_TABLE: "/processor-fee-table",
  MIN_MAX_COPAY_STEP: "/min-max-copay-step",
  MIN_MAX_DIFFERENTIAL: "/min-max-differential",
  MIN_MAX_COPAY_DIFFERENTIAL: "/min-max-copay-differential",
  ADDITIONAL_PATIENT_PAY_STEPS: "/additional-patient-pay-steps",
  COPAY_SCHEDULE_STEPS: "/copay-schedule-steps",
  ADDITIONAL_PATIENT_PAY_STEPS_ADD: "/add-additional-patient-pay-steps",
  ADDITIONAL_PATIENT_PAY_STEPS_EDIT: "/edit-additional-patient-pay-steps",
  ADDITIONAL_PATIENT_PAY_STEPS_DISPLAY: "/display-additional-patient-pay-steps",
  COPAY_SCHEDULE_NOTE: "/copay-schedule-note",
  COPAY_SCHEDULE_STEPS_ADD: "/add-copay-schedule-steps",
  COPAY_SCHEDULE_STEPS_EDIT: "/edit-copay-schedule-steps",
  COPAY_SCHEDULE_STEPS_DISPLAY: "/display-copay-schedule-steps",
  PROCESSOR_FEE_TABLE_ADD: "/add-processor-fee-table",
  PROCESSOR_FEE_TABLE_EDIT: "/edit-processor-fee-table",
  PROCESSOR_FEE_TABLE_DISPLAY: "/display-processor-fee-table",
  COUPON_PATIENT_PAY_GPI_LIST_NOTE: "/coupon-patient-pay-note",
  COUPON_PATIENT_PAY_GPI: "/coupon-patient-pay-gpi",
  ADD_MINMAX_COPAY_STEP: "/add-minmax-copay-step",
  EDIT_MINMAX_COPAY_STEP: "/edit-minmax-copay-step",
  DISPLAY_MINMAX_COPAY_STEP: "/display-minmax-copay-step",
  ADD_MINMAX_DIFF_STEP: "/add-minmax-diff-step",
  EDIT_MINMAX_DIFF_STEP: "/edit-minmax-diff-step",
  DISPLAY_MINMAX_DIFF_STEP: "/display-minmax-diff-step",
  ADD_MINMAX_COPAY_DIFF_STEP: "/add-minmax-copay-diff-step",
  EDIT_MINMAX_COPAY_DIFF_STEP: "/edit-minmax-copay-diff-step",
  DISPLAY_MINMAX_COPAY_DIFF_STEP: "/display-minmax-copay-diff-step",
  ADD_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE:
    "/add-patientpay-table-additional-schedule",
  EDIT_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE:
    "/edit-patientpay-table-additional-schedule",
  DISPLAY_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE:
    "/display-patientpay-table-additional-schedule",
  DISCOUNT_PATIENT_PAY_TABLE: "/discount-patient-pay-table",
  DISCOUNT_PATIENT_PAY_TABLE_ADD: "/add-discount-patient-pay-table",
  DISCOUNT_PATIENT_PAY_TABLE_EDIT: "/edit-discount-patient-pay-table",
  DISCOUNT_PATIENT_PAY_TABLE_DISPLAY: "/display-discount-patient-pay-table",
  COUPON_PATIENT_PAY_GPI_LIST_NOTE: "/coupon-patient-pay-note",
  ADD_MINMAX_COPAY_STEP: "/add-minmax-copay-step",
  EDIT_MINMAX_COPAY_STEP: "/edit-minmax-copay-step",
  DISPLAY_MINMAX_COPAY_STEP: "/display-minmax-copay-step",
  ADD_MINMAX_DIFF_STEP: "/add-minmax-diff-step",
  EDIT_MINMAX_DIFF_STEP: "/edit-minmax-diff-step",
  DISPLAY_MINMAX_DIFF_STEP: "/display-minmax-diff-step",
  ADD_MINMAX_COPAY_DIFF_STEP: "/add-minmax-copay-diff-step",
  EDIT_MINMAX_COPAY_DIFF_STEP: "/edit-minmax-copay-diff-step",
  DISPLAY_MINMAX_COPAY_DIFF_STEP: "/display-minmax-copay-diff-step",
  ADD_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE:
    "/add-patientpay-table-additional-schedule",
  EDIT_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE:
    "/edit-patientpay-table-additional-schedule",
  DISPLAY_PATIENTPAY_TABLE_ADDIITIONAL_SCHEDULE:
    "/display-patientpay-table-additional-schedule",
  MAX_COPAY_SCHEDULE: "/max-copay-schedule",
  ADD_MAX_COPAY_SCHEDULE: "/add-max-copay-schedule",
  EDIT_MAX_COPAY_SCHEDULE: "/edit-max-copay-schedule",
  DISPLAY_MAX_COPAY_SCHEDULE: "/display-max-copay-schedule",
  MAX_COPAY_SCHEDULE_STEPS: "/max-copay-schedule-steps",
  DISCOUNT_PATIENT_PAY_TABLE: "/discount-patient-pay-table",
  DISCOUNT_PATIENT_PAY_TABLE_ADD: "/add-discount-patient-pay-table",
  DISCOUNT_PATIENT_PAY_TABLE_EDIT: "/edit-discount-patient-pay-table",
  DISCOUNT_PATIENT_PAY_TABLE_DISPLAY: "/display-discount-patient-pay-table",
  ADD_MAX_COPAY_SCHEDULE_STEPS: "/add-max-copay-schedule-steps",
  EDIT_MAX_COPAY_SCHEDULE_STEPS: "/edit-max-copay-schedule-steps",
  DISPLAY_MAX_COPAY_SCHEDULE_STEPS: "/display-max-copay-schedule-steps",
  COPY_COUPON_PATIENT_PAY_GPI_LIST: "/copy-coupon-patient-pay-schedule",
  COPY_DISCOUNT_PATIENT_PAY_TABLE: "/opy-discount-patient-pay-table",
  PHARMACY_NETWORKS: "/pharmacy-networks",
  COUPON_PATIENT_PAY_GPI_LIST: "/coupon-patient-pay-gpi-list-lookup",
  FORMULARY_STATUS_LIST: "/formulary-status-list",
  NON_STATE_COST_SOURCE_AND_TYPE: "/non-state-cost-source-and-type",

  COUPON_PATIENT_PAY_GPI_LIST: "coupon-patient-pay-gpi-list-lookup",
  FORMULARY_STATUS_LIST: "formulary-status-list",
  NON_STATE_COST_SOURCE_AND_TYPE: "non-state-cost-source-and-type",
  NOTE_GPI_COUPON_PATIENT_PAY: "/note-gpi-coupon-patient-pay",
  COPY_PROCESSOR_FEE_TABLE: "/copy-processor-fee-table",
  COUPON_PATIENT_PAY_GPI_LIST_PLANS: "/coupon-patient-pay-gpi-list-plans",
  ADD_COUPON_PATIENT_PAY_GPI_LIST: "/add-coupon-patient-pay-gpi-list",
  EDIT_COUPON_PATIENT_PAY_GPI_LIST: "/edit-coupon-patient-pay-gpi-list",
  DISPLAY_COUPON_PATIENT_PAY_GPI_LIST: "/display-coupon-patient-pay-gpi-list",
  PRICE_EDGE_SCHEDULE: "/price-edge-schedule",
  PHARMACY_NETWORKS: "/pharmacy-networks",
  PRESCRIBER_NETWORKS: "/prescriber-networks",
  GPI_SCREEN: "/gpi-screen",
  GPI_PRODUCT_ID: "/gpi-product-id",

  ADD_PRICE_EDGE_SCHEDULE: "/add-price-edge-schedule",
  EDIT_PRICE_EDGE_SCHEDULE: "/edit-price-edge-schedule",
  DISPLAY_PRICE_EDGE_SCHEDULE: "/display-price-edge-schedule",
  PHARMACY: "/pharmacy",
  PHARMACY_LIST: "/pharmacy-list",
  SUPER_NETWORK_LOOKUP: "super-network-lookup",

  PRICE_EDGE_SCHEDULE_SEQUENCE: "/price-edge-schedule-sequence",
  EDIT_PRICE_EDGE_SCHEDULE_SEQUENCE: "/edit-price-edge-schedule-sequence",
  DISPLAY_PRICE_EDGE_SCHEDULE_SEQUENCE: "/display-price-edge-schedule-sequence",
  COPY_PRICE_EDGE_SCHEDULE: "/copy-price-edge-schedule",

  ADD_PRICE_EDGE_SCHEDULE_SEQUENCE: "/add-price-edge-schedule-sequence",
  PRICE_EDGE_SCHEDULE_NOTE: "/price-edge-schedule-note",
  EXTERNAL_GPI_LOOKUP: "/external-gpi-lookup"
};
export const VALIDATION_MESSAGES = {
  REQUIRED: "Value required.",
  MAXLENGTH: "Value cannot exceed {1} characters.",
  MIN: "Value cannot be less than {1}.",
  MAX: "Value cannot be greater than {1}.",
  INVALID_DATE: "Invalid date.",
};

export const BUSINESS_OBJECT = {
  ACCUMS: "patientpay",
};

export const WRITE_ACCESS_CTA = [
  "EDIT",
  "DELETE",
  "ADD",
  "COPY",
  "HIDE",
  "UNHIDE",
  "INACTIVATE",
  "INACTIVE"
];

export const externalProgram = {};

export const EXTERNAL_PAGE_URI = {
  MESSAGE_CODE: "/select-message",
  MULTI_SOURCE: "/multi-source-code-list",
  STATE_LIST: "/state-list",
  THIRD_PARTY: "/third-party-exception",
  MAC_LIST: "/mac-list",
  GPI_MSC_LIST: "/gpi-msc-list",
};

/* cSpell:disable */
export const LEGACY_SCREEN_VIEW = {
  RCPLN018: "RCPLN013I",
  RCFCH004: "RCFCH003I",
  RCMSG002: "RCMSG008",
  RCRAL004: "RCRAL003I",
  RCRAD900: "RCRAL003I",
  RCDFL005: "RCDFL003I",
  RCDCL005: "RCDCL003I",
  RCND1004: "RCND1003I",
  RCGP3004: "RCGP3003I",
  RCPKL005: "RCPKL003I",
  RCTSC003: "RCTSD001I",
  RCPS3001: "RCPS3004I",
  RCAL1005: "RCAL2003",
  RCSCS004: "RCSCS003I",
  RCPAL004: "RCPAD001I",
  RCSTL005: "RCSTL002I",
  RCGP3004: "RCGP4001I",
  RCSNH990: "RCSND002I",
  RCMCL005: "RCMCP001I",
  RCPS3001: "RCPS3014",
  RCFS1005: "RCFS1003I",
  RCMSL005: "RCMSL003I",
  RCGPI031: "RCGP4001I",
  RCCSS001: "RCCSS005",
  RCDUW001: "RCPHN004I",
  RCPS4005I: "RCPS4005I",
  RCAPP001I: "RCAPP001I",
  RCFS2001I: "RCFS2001I",
  RCPTF009: "RCPTF009",
  RCAPS004: "RCAPT002I",
  RCPAL002I: "RCPAL002I",
};

export const URL_SCREEN_NO = {
  RCSNH990: "api/superNetwork/superNetworkData",
  RCMCL005: "api/aptAddlPatPaySchedStps/macListValues",
};

export const LOCAL_SCREEN_VIEW = {
  RCCSH004: "COPAY_SCHEDULE_STEPS",
  RCPS4035: "DISPLAY_PATIENT_PAY_TABLE_DETAIL",
  RCPS3001: "PATIENT_PAY_SCHEDULE_DISPLAY",
  RCAPT004: "ADDITIONAL_PATIENT_PAY_SCHEDULE_DISPLAY",
  RCAPS004: "ADDITIONAL_PATIENT_PAY_SCHEDULE_DISPLAY",
};

export const SCHEDULES_DATA_KEY = {
  RCAPT004: "selectedAdditionalPatients",
  RCAPS004: "selectedAdditionalPatients",
  RCPS3001: "selectedPatients",
  RCPS4035: "selectedPatients",
  RCCSH004: "selectedSchedules",
};

export const EXTERNAL_SCHEDULES_DATA_KEY = {};
export const FN_SHIFT_KEY_MAPPING = {
  F1: "F13",
  F2: "F14",
  F3: "F15",
  F4: "F16",
  F5: "F17",
  F6: "F18",
  F7: "F19",
  F8: "F20",
  F9: "F21",
  F10: "F22",
  F11: "F23",
  F12: "F24",
};

export const VALID_FUNCTION_KEYS = [
  "F1",
  "F2",
  "F3",
  "F4",
  "F5",
  "F6",
  "F7",
  "F8",
  "F9",
  "F10",
  "F11",
  "F12",
  "F13",
  "F14",
  "F15",
  "F16",
  "F17",
  "F18",
  "F19",
  "F20",
  "F21",
  "F22",
  "F23",
  "F24",
];
export const NO_CHANGE_OF_INFO = "No Change of Information";
